import { AnimatePresence, motion } from "framer-motion";
import { MELZ_FIGURES } from "../lib/tokens";

/**
 * MelzAI, standing. He lives off to one side — tall, thin, bottom-anchored —
 * so the working surface stays free. The plate changes with his mode; a talking
 * video drops into the same slot later.
 */
export const MelzFigure = ({ mode, live, thinking, align = "left", height = "88%", width = "24%" }) => {
  const key = MELZ_FIGURES[mode] ? mode : "Clarify";
  const glow = live ? "120,215,255" : "255,196,120";
  const side = align === "right" ? { right: 0 } : { left: 0 };

  return (
    <div
      className="pointer-events-none absolute bottom-0 z-[6] hidden md:block"
      style={{ ...side, height, width }}
      data-testid="melz-figure"
      data-melz-mode={key}
    >
      {/* the pool of light he stands in — stops him floating */}
      <motion.div
        aria-hidden
        className="absolute bottom-0 left-1/2 h-[7%] w-[92%] -translate-x-1/2 rounded-[50%]"
        animate={{ opacity: thinking ? [0.5, 1, 0.5] : 0.85 }}
        transition={{ duration: 2.2, repeat: thinking ? Infinity : 0 }}
        style={{
          background: `radial-gradient(ellipse at 50% 50%, rgba(${glow},0.4), rgba(0,0,0,0) 70%)`,
        }}
      />
      <motion.div
        className="absolute inset-0"
        animate={{ scale: [1, 1.009, 1] }}
        transition={{ duration: 6.5, repeat: Infinity, ease: "easeInOut" }}
        style={{ transformOrigin: "50% 100%" }}
      >
        <AnimatePresence mode="wait">
          <motion.img
            key={key}
            src={MELZ_FIGURES[key]}
            alt=""
            data-testid="melz-figure-plate"
            className="absolute bottom-0 left-1/2 h-full w-full -translate-x-1/2 object-contain object-bottom"
            initial={{ opacity: 0, y: 12 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.75, ease: [0.2, 0.8, 0.2, 1] }}
            style={{
              filter: live
                ? `drop-shadow(0 0 30px rgba(${glow},0.42)) saturate(0.86) brightness(1.04)`
                : `drop-shadow(0 0 24px rgba(${glow},0.26))`,
            }}
          />
        </AnimatePresence>
      </motion.div>
    </div>
  );
};

export default MelzFigure;
